export * from "./isLocation";
